import FlavourConfig from '../../../../shared/config/flavours';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const TopBarLogo = styled.img<{ margin: boolean }>`
  align-self: center;
  height: ${FlavourConfig.sizes.topBarLogo * Screen.widthRatio}px;
  margin-left: ${16 * Screen.widthRatio}px;
  margin-right: ${(props) => (props.margin ? 20 : 0) * Screen.widthRatio}px;
  position: ${FlavourConfig?.positions?.topBarLogo?.relative
    ? 'relative'
    : 'static'};
  top: ${-FlavourConfig?.positions?.topBarLogo?.y * Screen.widthRatio}px;
`;

TopBarLogo.defaultProps = {
  src: FlavourConfig.images.topBarLogo,
};

export default withImage(TopBarLogo, false);
